export const homeStyles = {
	card1: {
		title: {
			width: 500,
			margin: 80,
			marginBottom: 20,
			textAlign: 'center',
		},
		text: {
			width: 600,
			textAlign: 'center',
			marginLeft: 70,
			fontSize: 15,
		},
		titleSmall: {
			textAlign: 'center',
			fontSize: 20,
			margin: 10,
			marginTop: 40,
		},
		textSmall: {
			textAlign: 'center',
			fontSize: 15,
			margin: 10
		},
		button: {
			marginLeft: 0,
			borderRadius: 20,
			paddingLeft: 25,
			paddingRight: 25,
			fontSize: 13,
			fontWeight: 'bold',
			backgroundColor: '#25a8e3',
			borderWidth: 0,
		    transform: `translate(${300}px, ${0}px)` 
			
		},
		buttonSmall: {
			marginLeft: 80,
			marginBottom: 20,
			borderRadius: 20,
			fontSize: 10,
			fontWeight: 800,
			backgroundColor: '#25a8e3',
			borderWidth: 0
		}
	},
	card2: {
		title: {
			color: 'white',
			fontSize: 20,
			marginTop: 30,
			marginLeft: 60
		},
		input: {
			paddingTop: 15,
			paddingBottom: 15,
			borderWidth: 1,
			borderColor: '#aeaeae',
			borderRadius: 0,
			color: 'grey',
			fontFamily: 'Nunito'
		},
		button: {
			paddingTop: 12,
			paddingBottom: 12,
			paddingLeft: 40,
			paddingRight: 40,
			backgroundColor: '#669ac9'
		},
		col: {
			marginLeft: -14,
			marginRight: -18,
		}
	},
	card3: {
		title: {
			width: '100%',
			 margin: 20,
			textAlign: 'center',
			marginBottom: 20,
			fontSize: '20px',
			
		},
		text: {
			width: '100%',
			textAlign: 'center',
			// marginLeft: 20,
			fontSize: 15,
		}
	}
};